module.exports = __webpack_public_path__ + "img/Doctor1.1cf4d0e5.png";